// EL BUSCADOR DEL MENÚ DE LA IZQUIERDA (Lissette 2026-10-15).
//
// "puedes colocar un buscador en el tope del menú de la izquierda, el
// principal, es que tenemos muchas funciones y a la gente se le es más fácil
// buscarla".
//
// Busca sin importar mayúsculas ni acentos ("facturas" encuentra "Facturas",
// "polizas" encuentra "Pólizas"), en el nombre del módulo, en el nombre de su
// sección ("Marketing", "Reportes y Metas"…) y en unas pocas palabras más que
// la gente usa para lo mismo (`SINONIMOS`). Varias palabras = todas tienen
// que estar ("pagos mes" → "Pagos del Mes").

export function normalizarMenu(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * Otras formas de llamar a un módulo. Solo lo que el nombre no dice ya: si
 * la palabra está en la etiqueta, sobra aquí.
 */
export const SINONIMOS = {
  dashboard: 'inicio home panel resumen',
  clients: 'clientes ficha personas',
  leads: 'prospectos interesados',
  policies: 'polizas seguros',
  payment_tracker: 'pagos cobros mes',
  mass_email: 'correo masivo email masivo envio',
  sent_emails: 'correos enviados',
  campaigns: 'feriados cumpleanos plantillas',
  surveys: 'encuestas satisfaccion opinion',
  quotes_invoices: 'cotizaciones cotizar presupuesto',
  invoices: 'facturas cobrar',
  signatures: 'firmar firmas documentos',
  requests: 'documentos solicitudes subir',
  vault: 'contrasenas claves boveda portal',
  my_vault: 'contrasenas claves personal',
  company_info: 'telefonos companias aseguradoras numeros',
  tasks: 'pendientes por hacer',
  calendar: 'agenda citas',
  conversations: 'mensajes sms whatsapp chat',
  team_chat: 'chat equipo mensajes',
  help_center: 'ayuda manual soporte',
  profile: 'perfil cuenta firma',
  import: 'importar excel csv subir',
  renewals: 'renovar renovaciones',
};

/**
 * ¿Este módulo sale con esta búsqueda? `extra` = texto adicional (la sección
 * del menú, en los dos idiomas).
 */
export function coincideEnMenu(item, consulta, extra = '') {
  const q = normalizarMenu(consulta);
  if (!q) return true;
  const pajar = normalizarMenu(
    [item.label, String(item.id || '').replace(/_/g, ' '), SINONIMOS[item.id] || '', extra].join(' '),
  );
  return q.split(/\s+/).every((palabra) => pajar.includes(palabra));
}
